import axios from '@/libs/api.request';
import config from '@/config';

export const FILE_SERVER = axios.getFileServerUrl() + '/';

export const UPLOAD_FILE_API = axios.getBaseUrl() + '/api/files/uploadFiles';

export const UPLOAD_FILE_API_PATH = axios.getBaseUrl() + '/api/files/uploadFilesWithPath';

export const DOWNLOAD_SERVER = process.env.VUE_APP_DOWNLOAD_FILE_URL+ '/';
export const manualUpload = data => {
    return axios.request({
        url: UPLOAD_FILE_API,
        data: data,
        method: 'post'
    });
};

